import { setSessionCookies } from 'portal-utils/session-cookies'
import {
  I18N_MOCK
} from 'portal-modules/common/constants/keys'

export const redirectToHome = () => {
  window.location = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
}

export const updateLocaleCookie = ({ language_preference, isRedirectionRequired = true }) => {
  const expires = new Date()
  expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 14)

  setSessionCookies(I18N_MOCK, language_preference, false, {
    expires,
    maxAge: 60 * 60 * 24 * 14,
  })

  isRedirectionRequired && redirectToHome()
}
